import React from 'react';
import { Popup } from 'semantic-ui-react';

import { useTranslation } from 'react-i18next';
import ProfileImage from '../profile-image';
import { PopoverContent } from '../profile/popover';
import { Recognition } from '@modules/social/types/objects';
import Icon from '../icon';
import { LoggedUser, SimpleUser } from '@common/types/objects';
import Card from '../card';
import { useHistory } from 'react-router';

type Props = {
  loggedUser: LoggedUser;
  recognition?: Recognition;
  isChannel?: boolean;
  network?: string | null;
  user?: SimpleUser;
  enablePopovers?: boolean;
  isNotifiedUser?:boolean;
  match: any;
};

const RecognitionCard = ({
  loggedUser,
  recognition,
  isChannel,
  network,
  user,
  match,
  enablePopovers = false,
  isNotifiedUser = false
}: Props) => {
  const { t } = useTranslation();
  const history = useHistory();

  const shouldShowPopovers =
    enablePopovers && !isChannel && user?.id !== loggedUser.id;

  return (
    <div className="Message__content fs-exclude">
      <Card containerClassName="Recognition__Card tw-p-6">
        <Card.Header className="Recognition__Card__Header">
          <div className="Recognition__Card__Profile">
            <div>
              <ProfileImage
                size={40}
                user={isNotifiedUser ? loggedUser : user || {}}
                enablePopover={shouldShowPopovers}
                className="tw-rounded-full"
              />
            </div>
            <div>
              <Icon type="highfive__filled" color="#111827" />
            </div>
          </div>
          <div className="tw-flex tw-flex-col">
            <p className="tw-m-0 tw-text-[13px]">
              {isNotifiedUser
                ? t('social:recognition_send_message_by')
                : t('social:recognition_send_message_to')}
            </p>
            <Popup
              className="popover ProfilePopover"
              trigger={
                <div className={shouldShowPopovers ? 'tw-cursor-pointer' : ''}>
                  <p className="tw-text-base tw-m-0 tw-font-medium">
                    {user?.full_name}
                  </p>
                </div>
              }
              flowing
              hoverable
              mouseEnterDelay={500}
              mouseLeaveDelay={500}
              position="top left"
              disabled={!shouldShowPopovers}
            >
              <PopoverContent
                user={user && user}
                loggedUserId={loggedUser.id}
                network={network}
                history={history}
                match={match}
              />
            </Popup>
          </div>
        </Card.Header>
        <Card.Content className="Recognition__Card__Content tw-flex tw-flex-col tw-gap-4 tw-p-0">
          <p className="tw-text-2xl tw-m-0 tw-font-playfair tw-font-medium tw-text-white tw-leading-snug">
            &ldquo;{recognition?.text || ''}&rdquo;
          </p>
          <div className="Recognition__Card_Footer">
            {recognition?.values?.map((value) => (
              <div
                className="Recognition__Card_Footer_Tag tw-bg-[rgba(255,255,255,0.1)]"
                key={value.id}
              >
                {value.name}
              </div>
            ))}
          </div>
        </Card.Content>
      </Card>
    </div>
  );
};

export default RecognitionCard;
